import React, { useState, useEffect } from 'react';

import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { useNavigate, Link } from 'react-router-dom';

import api from '../../../../Services/api';
import './index.css'
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';

import MonthlyReport from '../../../../Component/Client/ClientMonthlyReport';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement);

const COLORS = {
  success: '#0BDA51',
  overall: '#50c878',
  danger: '#B22222',
  notUploaded: 'white',
  warning: '#EFCC00'
};

const months = [
  { name: "JANUARY", value: "01" },
  { name: "FEBRUARY", value: "02" },
  { name: "MARCH", value: "03" },
  { name: "APRIL", value: "04" },
  { name: "MAY", value: "05" },
  { name: "JUNE", value: "06" },
  { name: "JULY", value: "07" },
  { name: "AUGUST", value: "08" },
  { name: "SEPTEMBER", value: "09" },
  { name: "OCTOBER", value: "10" },
  { name: "NOVEMBER", value: "11" },
  { name: "DECEMBER", value: "12" }
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);

const ClientReportTable = ({ filter,month,year, onPercentagesChange }) => {
  let data = sessionStorage.getItem('user');
  let clientData = JSON.parse(data);
  let companyId = clientData.id;

  const currentDate = new Date();
 
  const navigate = useNavigate();
  const currentMonth = currentDate.getMonth() + 1;
  const currentDay = currentDate.getDate();
  const previousMonthName = months[(currentMonth - 1 - 1 + 12) % 12].name;

  const [clientChartData1, setClientChartData1] = useState({});
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  const[loading,setLoading] = useState(true);
  const [report, setReport] = useState(false);
 
  const [showModal, setShowModal] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState(null);
  const [monthlyData, setMonthlyData] = useState({});  // Data for current month
  const [selectedMonthData, setSelectedMonthData] = useState({});  // Data for selected month (for report)
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const[selectedFilter,setSelectedFilter] = useState('all')
  useEffect(() => {
    // Make sure you pass the correct values when the data is available
    const { rejectedPercent, notUploadedPercent } = getRejectedAndNotUploadedPercentages(monthlyData);
    onPercentagesChange(rejectedPercent, notUploadedPercent);
    console.log("percentage",rejectedPercent, notUploadedPercent);
  }, [monthlyData]);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  // Fetch current month's data when the component mounts
  useEffect(() => {
   
      setErrorSnackbarOpen(true);
      setSnackbarErrorMessage('Compliance start Date is 2nd');

      fetchCurrentMonthData(companyId, currentMonth <=10 ? `0${currentMonth-1}` : currentMonth-1, currentYear);
    
  }, [companyId, currentMonth, currentYear]);

  // Fetch selected month data for the report when selectedMonth or selectedYear changes
  useEffect(() => {
    if (selectedMonth && selectedYear) {
      fetchSelectedMonthData(companyId, selectedMonth, selectedYear);
    }
  }, [selectedMonth, selectedYear]);
  const handleMonthChange = (event) => setSelectedMonth(event.target.value);
  const handleYearChange = (event) => setSelectedYear(event.target.value);
  // Fetch data for current month (status)
  const fetchCurrentMonthData = async (companyId, month, year) => {
    try {
      const response = await api.client.getEstablishmentMonthlyData(companyId, month, year);
      if (response.status === 200) {
        const chartData = response.data;
        setClientChartData1((prevData) => ({
          ...prevData,
          [companyId]: chartData,
        }));
        setMonthlyData(chartData);
        setLoading(false)
        const { rejectedPercent, acceptedPercentage, underReviewPercent } = getRejectedAndNotUploadedPercentages(chartData);
        if (rejectedPercent === 0 && acceptedPercentage === 0 && underReviewPercent === 0) {
          setIsDataEmpty(true);
        } else {
          setIsDataEmpty(false);
        }
      
      } 
      else if (response.status === 404) {
         setLoading(false)
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setMonthlyData(null);
     

    }
    else if (response.status === 400) {
       setLoading(false)
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
      
    }
    else if (response.status === 500) {
       setLoading(false)
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
      
    }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
      }
    } catch (error) {
      console.error('Error fetching current month data', error);
    }
  };

  // Fetch data for selected month (for report)
  const fetchSelectedMonthData = async (companyId, month, year) => {
    try {
      const response = await api.client.getEstablishmentMonthlyData(companyId, month, year);
      if (response.status === 200) {
        const chartData = response.data;
        setSelectedMonthData(chartData);
        setReport(true);
      } else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage(response.data.message);
        setReport(false);
      }
    } catch (error) {
      console.error('Error fetching selected month data', error);
    }
  };
  const handleFilterChange = (filter) => {
    const percentages = getRejectedAndNotUploadedPercentages(monthlyData);
  if (
    (filter === 'rejected' && percentages.rejectedPercent === 0) ||
    (filter === 'accepted' && percentages.acceptedPercentage === 0) ||
    (filter === 'underReview' && percentages.underReviewPercent === 0)
  ) {
  
    navigate('/monthly-data', {
      state: {
   
        month: currentMonth <=10 ? `0${currentMonth-1}` : currentMonth-1,
        year: currentYear,
      },
  }) 
}
else{
    navigate('/monthly-data', {
      state: {
         filter: filter,
        month: currentMonth <=10 ? `0${currentMonth-1}` : currentMonth-1,
        year: currentYear,
      },
    });
  }
  };

  const getRejectedAndNotUploadedPercentages = (monthlyData) => {
    if (monthlyData && monthlyData.data) {
      const rejected = monthlyData.data.RejectedPercent || 0;  // Safe access to rejected percentage
      const underReview = monthlyData.data.UnderReviewPercent || 0;
      const accepted = monthlyData.data.AcceptedPercent || 0;  // Safe access to under review percentage
      return { rejectedPercent: rejected, underReviewPercent: underReview, acceptedPercentage: accepted };
  } else {
      // Handle the case where data might not be available
      console.error('Data is missing or incorrect structure');
      return { rejectedPercent: 0, underReviewPercent: 0 ,acceptedPercentage: 0};
  }
  };

 
  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="success"
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
      >
        <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="error"
        open={errorSnackbarOpen}
        autoHideDuration={2000}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
        onClose={() => setErrorSnackbarOpen(false)}
      >
        <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
      </Snackbar>
 

      <div className="d-grid" >
        <div className=" bg-dark" style={{ border: '1px solid lightgray'}}>
      
          <h6 className="text-center bg-dark text-light p-2 m-0">{previousMonthName}-Month Status</h6>
         
          <section >
           {loading? (
            <>
          <h4 clasName="p-2 text-center text-light">Loading....</h4>
            </>
           ): 
            isDataEmpty ? (
                <div style={{borderTop:"1px solid lightgray",cursor:'pointer'}}>
                           
                <p onClick={()=>handleFilterChange('')} className="p-2 text-center text-warning" style={{fontSize:"12px",cursor:"pointer"}}>Click here to upload {previousMonthName} month Monthly Data <i class="bi bi-arrow-right text-danger "></i></p>
                </div>
 
            ) : (
                
              <>
              {monthlyData ? (
      <table className="table table-hover table-light m-0 pt-0" style={{ borderCollapse: 'collapse', cursor: 'pointer' }}>
        <thead>
          <tr>
            <td className="text-dark text-center font-bold">Actions</td>
            <td className="text-dark text-center font-bold">Percentage</td>
          </tr>
        </thead>
        <tbody>
        
        <tr
 
  style={{cursor: getRejectedAndNotUploadedPercentages(monthlyData).rejectedPercent > 0 ? 'pointer' : 'default' }}
  {...(getRejectedAndNotUploadedPercentages(monthlyData).rejectedPercent > 0
    ? { onClick: () => handleFilterChange('rejected') }
    : {})}
>
  <td title="Click here to view notComplied items" className="text-center ">Not Complied</td>
  <td title="Click here to view notComplied items" className="text-danger text-center" style={{ fontWeight: 'bold' }}>
    {getRejectedAndNotUploadedPercentages(monthlyData).rejectedPercent}%  
  </td>
 

</tr>


<tr
  
  style={{cursor: getRejectedAndNotUploadedPercentages(monthlyData).rejectedPercent > 0 ? 'pointer' : 'default' }}
  {...(getRejectedAndNotUploadedPercentages(monthlyData).acceptedPercentage > 0
    ? { onClick: () => handleFilterChange('accepted') }
    : {})}
>
  <td title="Click here to view complied items" className="text-center">Complied</td>
  <td title="Click here to view complied items" className="text-success text-center" style={{ fontWeight: 'bold' }}>
    {getRejectedAndNotUploadedPercentages(monthlyData).acceptedPercentage}%
  </td>
</tr>
<tr
  
  style={{  cursor: getRejectedAndNotUploadedPercentages(monthlyData).underReviewPercent > 0 ? 'pointer' : 'default' }}
  {...(getRejectedAndNotUploadedPercentages(monthlyData).underReviewPercent > 0
    ? { onClick: () => handleFilterChange('underReview') }
    : {})}
>
  <td title="Click here to view underReview items" className="text-center">Under Review</td>
  <td title="Click here to view underReview items" className="text-secondary text-center" style={{ fontWeight: 'bold' }}>
    {getRejectedAndNotUploadedPercentages(monthlyData).underReviewPercent}%
  </td>
</tr>
        </tbody>
      </table>
    ) : (
      <div className="text-center text-light" style={{borderTop:'1px solid lightgray'}}>
        <p className="p-2 text-danger text-center">Monthly data not created</p>
      </div>
    )}
    </>
                
            )}
          
         
          </section>

     
        </div>

        <section className="mt-2" style={{ border: '1px solid lightgray',height:'170px'}}>
        
          <h6 className="text-light text-center p-2" style={{ backgroundColor: 'rgba(0,0,0,0.8)'}}>Assessment Report</h6>
       
          <div className="mx-4 mt-4 " style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <select value={selectedMonth || ''} onChange={handleMonthChange} style={{ marginRight: '10px', cursor:'pointer',border:'1px solid black' }}>
              <option value="" disabled>Select Month</option>
              {months.map((month) => (
                <option key={month.value} value={month.value}>{month.name}</option>
              ))}
            </select>
            <select value={selectedYear || ''} onChange={handleYearChange} style={{ cursor:'pointer' ,border:'1px solid black'}}>
              <option value="" disabled>Select Year</option>
              {years.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <div className="mb-4 mt-3 d-flex justify-content-center">
            <button className="btn btn-sm btn-danger mx-2" onClick={handleShow} disabled={!selectedMonth || !selectedYear || !report}>
              View Report
            </button>
          </div>
          <MonthlyReport showModal={showModal} onClose={handleClose} selectedMonth={selectedMonth} selectedYear={selectedYear} />
     
        </section>
      </div>
  
    </div>
  );
};

export default ClientReportTable;

